import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/campaign",

        async devicesFilterList({ id, isAnunciante }) {
            const url = this.url(
                `/${id}/filtro/open/local${
                    isAnunciante ? "/anunciante" : ""
                }`
            );

            return Vue.http.get(url);
        },

        async toogleDeviceFilter({ id, itemLocalId, type }) {
            const url = this.url(`/${id}/filtro/local/${itemLocalId}`);

            return Vue.http.post(url, { type });
        },

        async listToFilter({ pagination, filters }) {
            const url = this.url(`/${pagination.amountPerPage}/to/filter`);
            const query = {
                filter: filters.search
            };

            return await Vue.http.get(url, {
                params: query
            });
        },

        async levels() {
            const url = this.url('/levels');

            return Vue.http.get(url);
        },

        async getAllCampaigns({ pagination, filters }){
            const url = this.url('/all');

            const query = {
                search: filters.search,
                archived: filters.archived,
                page: pagination.page,
            };

            const list = await Vue.http.get(url, {
                params: query
            });

            return list.content
        },

        async countAllCampaigns({ filters }) {
            const url = this.url('/all');

            const query = {
                search: filters.search,
                archived: filters.archived,
                page: 0,
            };

            const list = await Vue.http.get(url, {
                params: query
            });

            return list.totalElements
        },

        async levelsList({ pagination, filters }) {
            const url = this.url(
                `/level/${filters.level}/${pagination.page}/${pagination.amountPerPage}`
            );

            const query = {
                search: filters.search,
                archived: filters.archived
            };

            return Vue.http.get(url, {
                params: query
            });
        },

        async list({ pagination, filters }) {
            const url = this.url(
                `${filters.thirdParty ? "/anunciante" : ""}/${
                    pagination.page
                }/${pagination.amountPerPage}`
            );
            const query = {
                nome: filters.search,
                ordem: filters.orderBy,
                desc: filters.desc,
                filter: filters.search,
                archived: filters.archived
            };

            return await Vue.http.get(url, {
                params: query
            });
        },

        async count({ filters }) {
            const url = this.url(
                `${filters.thirdParty ? "/anunciante" : ""}/paginacao${
                    filters.isLevels ? `/level/${filters.level}` : ""
                }`
            );

            const query = {
                nome: filters.search,
                filter: filters.search,
                archived: filters.archived
            };

            return await Vue.http.get(url, {
                params: query
            });
        },

        async find(id) {
            const url = this.url(`/${id}`);

            return await Vue.http.get(url);
        },

        async create({ data }) {
            const url = this.url();
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.post(url, data).catch(error => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async edit({ id, data }) {
            const url = this.url(`/${id}`);
            return await Vue.http.put(url, data);
        },

        async duplicate({ id }) {
            const url = this.url(`/${id}/copia`);

            return await Vue.http.post(url);
        },

        async remove({ id }) {
            const url = this.url(`/${id}`);

            return await Vue.http.delete(url);
        },

        async activate(id) {
            const url = this.url(`/${id}/status`);

            return await Vue.http.put(url);
        },

        async repeat(id) {
            const url = this.url(`/${id}/repetir`);

            return await Vue.http.put(url);
        },

        async archive(id) {
            const url = this.url(`/${id}/archived`)

            return await Vue.http.put(url)
        },

        async order({ id, order }) {
            const url = this.url(`/${id}/ordem/${order}`);

            return await Vue.http.put(url);
        },

        async levelOrder({ id, order, level }) {
            const url = this.url(`/${id}/level/${level}/ordem/${order}`);

            return await Vue.http.put(url);
        },

        async devicesList(id) {
            let url = this.url();

            if (id) url += `/${id}`;

            url += "/filtro/local";

            return await Vue.http.get(url);
        },

        async statistics({ advertisingId, date, mode, establishments, local }) {
            const url = this.url(`/${advertisingId}/estatistica`);
            const query = {
                "data.min": date && date.min,
                "data.max": date && date.max,
                estabelecimentos: establishments,
                locais: local,
                tipoEstatisticaCampanha: mode
            };

            return Vue.http.get(url, {
                params: query
            });
        },

        async interactionStatistics({
            advertisingId,
            interactionId,
            date,
            mode,
            establishments,
            local
        }) {
            const url = this.url(
                `/${advertisingId}/interacao/${interactionId}/estatistica`
            );
            const query = {
                "data.min": date.min,
                "data.max": date.max,
                visualizacao: mode,
                estabelecimentos: establishments,
                locais: local
            };

            return await Vue.http.get(url, {
                params: query
            });
        }
    },
    base
);
